// import axios from "../../service";

export const state = {
  transactionList: {}
};

export const mutations = {
  INIT_TRANSACTION_LIST(state, newValue) {
    state.transactionList = newValue;
  }
};

export const getters = {
  isTransaction(state) {
    return {
      report: state.transactionList.report || [],
      total: state.transactionList.total || 0
    };
  }
};

export const actions = {
  // async fetchTransaction({ commit }, data) {
  //   try {
  //     let resp = await axios.get("/user/report/transaction", { params: { ...data } });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("INIT_TRANSACTION_LIST", resp.data);
  //     return { status: true };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },
};
